import {
    extractProperties,
    isEmpty,
} from './'
import {CaseReducer} from '@reduxjs/toolkit'
import {NinchatChannelMemberPartedEvent} from '../types/events'
import {NinchatState} from 'api/types'
import {userDisconnected} from 'utils/channels'

export const channelMemberParted: CaseReducer<NinchatState> = (state, action) => {
    const {
        channel_id,
        event_cause, // eslint-disable-line @typescript-eslint/no-unused-vars
        user_id,
        ...rest
    } = extractProperties<NinchatChannelMemberPartedEvent>(action.payload)

    isEmpty(rest)
    // mark user as disconnected
    userDisconnected(state._users[user_id])

    delete state.user_channels[channel_id]?.channel_members?.[user_id]

    const {channel_members = {}} = state.user_channels[channel_id]
    state.user_channels[channel_id].channel_member_count = Object.keys(channel_members).length
}
